export const css = {
	oneaction: '_3MNOPdXc',
	' _key': 'apic-theme/apic/quiz-widgets/pretest-review'
};

export default css;
